import React from "react";

import { Container } from "react-bootstrap";
import FadeUpTrigger from "../animation/FadeUpTrigger";

import HeaderNormal from "../components/header/HeaderNormal";
import BoxRight from "../components/box-right/BoxRight";
import TitleSection from "../components/heading/TitleSection";
import ServiceTow from "../components/services/ServiceTow";
import Team from "../components/team/Team";
import BrandClient from "../components/brand-client/BrandClient";
import NextPageContent from "../components/next/NextPageContent";
import Footer from "../components/footer/Footer";
import TestimonialTow from "../components/testimonial/TestimonialTow";
import { Helmet } from "react-helmet";
import BoxImageVertical from "../components/box-image-vertical/BoxImageVertical";
import TitleCover from "../components/heading/title-cover/TitleCover";
import DsnGrid from "../components/DsnGrid";
import ButtonDefault from "../components/button/button-default/ButtonDefault";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

const headerContent = {
  title: "THE ART OF HIDDEN WORLDS",
  description: `I craft music, stories, and soundscapes from unseen realms, places you feel more than see, 
    guided by breath, shadow, and imagination.`,
};

function About() {
  return (
    <React.Fragment>
      <Helmet>
        <title>About | Mystirien</title>
        <meta property="og:title" content="About | Mystirien" />
        <meta
          property="og:description"
          content="A wandering Celtic-fantasy artist conjuring atmospheric, folk-inspired music that feels like nostalgia for places you've never been."
        />
        <meta property="og:url" content="https://mystirien.com/about" />
        <meta
          property="og:image"
          content="https://mystirien.com/assets/img/mystirien-og.jpg"
        />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      {/*Start Header*/}
      <HeaderNormal
        className="background-section"
        description={headerContent.description}
      >
        {headerContent.title}
      </HeaderNormal>

      {/*Start Box Right Info*/}
      <BoxRight
        className="mb-section text-center"
        src="/assets/img/neverland.jpg"
        parallaxFrom={{ scale: 1.2 }}
        parallax={{ scale: 1 }}
        overlay={4}
      >
        <FadeUpTrigger>
          <h3>Greetings Traveler</h3>
          <p className="mt-30 m-w750 dsn-auto">
            In this adventure, I make music and step into hidden worlds, feeling
            a quiet nostalgia for places I’ve never been, yet they call to me.
            The whispers of these unseen realms move through me, shaping stories
            and soundscapes that invite others to follow, to wander, and to
            discover what lies just beyond perception
          </p>
        </FadeUpTrigger>
      </BoxRight>
      {/*End Box Right Info*/}

      {/*Start Box Info With Image*/}
      <BoxImageVertical
        src="/assets/img/mystirien.jpg"
        className="section-margin"
      >
        <TitleCover>Mystirien</TitleCover>
        <FadeUpTrigger>
          {(ref) => (
            <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
              <h2 className="title-section border-line-left" ref={ref}>
                Mystirien
              </h2>
              <h6 ref={ref}>
                Sometimes you need to step away from the world to find your true
                path.
              </h6>
              <p ref={ref}>
                I am a wanderer of the quiet realms, a seeker of forgotten
                paths. My journeys have taken me to places where the stars
                whisper secrets and the wind carries ancient tales. I have
                walked beneath forgotten skies and mapped the silence between
                stars. I dwell where the river turns back on itself, where time
                flows like a hidden stream. If you listen closely, you can hear
                the echoes of my footsteps in the stillness of the night.
              </p>
              <div className="button-box" ref={ref}>
                <ButtonDefault
                  text="Join Me"
                  icon={faAngleRight}
                  href="https://www.youtube.com/@mystirien?sub_confirmation=1"
                  target="_blank"
                />
              </div>
            </DsnGrid>
          )}
        </FadeUpTrigger>
      </BoxImageVertical>
      {/*End  Box Info With Image*/}

      {/*Start Service Section*/}
      <Container className="section-margin">
        <TitleSection description="Fields I Explore">
          Adventures in Creation
        </TitleSection>
        <ServiceTow col={2} colMobile={1} />
      </Container>
      {/*End Service Section*/}

      {/*Start Team*/}
      <section className="section-margin background-section section-padding">
        <Container className="dsn-right-container">
          <TitleSection description="The Hidden Fellowship">
            Whispers that follow me everywhere
          </TitleSection>
          <Team loop grabCursor />
        </Container>
      </section>
      {/*End Team*/}

      {/*Start Service Section*/}
      <Container className="section-margin">
        <TitleSection description="Whispers">
          Echoes From the Hidden
        </TitleSection>
        <TestimonialTow grabCursor loop />
      </Container>
      {/*End Service Section*/}

      {/*Start Brand*/}
      <Container className="section-margin">
        <TitleSection description="Contact">
          Follow me on my magical journeys
        </TitleSection>
        <BrandClient col={3} colTablet={2} colGap={2} rowGap={2} />
      </Container>
      {/*End Brand*/}

      <NextPageContent className="section-margin" />
      <Footer />
    </React.Fragment>
  );
}

export default About;
